module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/1@2x_7279013fd2b5e6b236a2cfaf6c5a0002.png";